module.exports = __webpack_public_path__ + "static/media/RedHatText-Medium.03f7db4c.ttf";